import angular from 'angular';
import uiRouter from 'angular-ui-router';

import taskDetailInfoModule from './screens/task-detail-info';
import taskDetailMsgsModule from './screens/task-detail-msgs';

import 'base-modal.scss';
import AttachmentsService from 'attachments.service'
import CommentsService from 'comments.service'
import acceptModalComponent from 'accept-modal';
import requestClosureModalComponent from 'request-closure-modal';
import requestHardwareModalComponent from 'request-hardware-modal';
import requestSoftwareModalComponent from 'request-software-modal';
import requeueModalComponent from 'requeue-modal';
import taskActionsMenuComponent from 'task-actions-menu';
import taskDetailMenuComponent from 'task-detail-menu';
import taskDetailComponent from './task-detail.component';

let taskDetailModule = angular.module('taskDetail', [
  uiRouter,
  taskDetailInfoModule.name,
  taskDetailMsgsModule.name,
])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $stateProvider
      .state('engineer.tasks.task-detail', {
        url: '/:taskId',
        abstract: true,
        template: '<task-detail task="$resolve.task" class="task-detail"></task-detail>',
        resolve: {
          task: (Task, $stateParams, $state) => {
            return Task.get({taskId: $stateParams.taskId}).$promise
              .then(response => new Task(response.task))
              .catch(reason => $state.go('engineer.tasks.task-list', { rejectReason: reason }));
          },
        }
      });
  })
  .service('Attachments', AttachmentsService)
  .service('Comments', CommentsService)
  .component('acceptModal', acceptModalComponent)
  .component('requestClosureModal', requestClosureModalComponent)
  .component('requestHardwareModal', requestHardwareModalComponent)
  .component('requestSoftwareModal', requestSoftwareModalComponent)
  .component('requeueModal', requeueModalComponent)
  .component('taskActionsMenu', taskActionsMenuComponent)
  .component('taskDetailMenu', taskDetailMenuComponent)
  .component('taskDetail', taskDetailComponent);

export default taskDetailModule;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/tasks/screens/task-detail/index.js